import { Instance, types } from 'mobx-state-tree';
import { ProjectStore } from './project-store';
import { ToolStore } from './tool-store';
import { UserStore } from './user-store';
import { UsersStore } from './users-store';

export const RootStore = types.model(
  'RootStore',
  {
    toolStore: ToolStore,
    projectStore: ProjectStore,
    usersStore: UsersStore,
    userStore: UserStore
  })
  .views(self => ({}))
  .actions(self => ({}));

export interface IRootStore extends Instance<typeof RootStore> {
}
